import React, { useCallback } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import NextLink from 'next/link'

import { useGa } from '../../providers/GaProvider'

export type LinkProps = {
  to: string
  className?: string
  children: React.ReactNode
  activeClassName?: string
  partiallyActive?: boolean
  href?: string
  scroll?: boolean
  prefetch?: boolean
  track?: boolean
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

export const Link = ({
  children,
  to,
  href,
  activeClassName,
  partiallyActive,
  className,
  track = true,
  onClick,
  ...other
}: LinkProps) => {
  to = to ?? href
  const internal = /^\/(?!\/)/.test(to)

  const router = useRouter()

  const ga = useGa()

  const sendClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      // if (to === "/preorder") {
      //   const gaEvent = {
      //     to: "https://store.solanamobile.com",
      //     event_name: "click",
      //   };
      //   ga("event", "preorder", gaEvent);
      //   // console.log("preorder event:", event);
      // } else {
      const gaEvent = {
        to: to,
        internal: internal,
        event_name: 'click',
      }
      ga('event', 'click', gaEvent)
      // console.log("sent event:", event);
      // }
      onClick && onClick(event)
    },
    [ga, internal, onClick, to]
  )

  const isActive = React.useMemo(() => {
    return (
      router.asPath === to || (partiallyActive && router.asPath.includes(to))
    )
  }, [partiallyActive, router.asPath, to])

  if (internal) {
    const { scroll, prefetch, ...aProps } = other
    return (
      <NextLink
        href={to}
        className={clsx(
          className,
          activeClassName && { [activeClassName]: isActive }
        )}
        scroll={scroll}
        prefetch={prefetch}
        passHref
        onClick={track ? sendClick : onClick ? onClick : undefined}
        {...aProps}
      >
        {children}
      </NextLink>
    )
  }
  return (
    <a
      href={to}
      {...other}
      className={clsx(className)}
      onClick={track ? sendClick : onClick ? onClick : undefined}
    >
      {children}
    </a>
  )
}

export const InlineLink = ({ to, children, ...props }: LinkProps) => (
  <Link to={to} {...props} rel="noopener noreferrer" target="_blank">
    {children}
  </Link>
)

export default Link
